import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e2efffd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-body" }
const _hoisted_2 = {
  key: 0,
  class: "data-image up"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 2,
  class: "image",
  src: "/img/not_found.jpg",
  alt: "Not Image"
}
const _hoisted_5 = {
  key: 3,
  class: "data-image down d-flex"
}
const _hoisted_6 = { class: "me-auto" }
const _hoisted_7 = {
  key: 0,
  class: "date-img"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
    return (_openBlock(), _createElementBlock("div", {
      key: image?.id || 0,
      class: _normalizeClass(_ctx.images.length === 1 ? 'image-list-one' : 'image-list')
    }, [
      _createElementVNode("div", _hoisted_1, [
        (image?.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(image.title), 1))
          : _createCommentVNode("", true),
        (image && image.fileName !== undefined && _ctx.src[image?.fileName])
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "image",
              src: _ctx.src[image.fileName],
              alt: image.fileName
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        (!_ctx.src[image?.fileName])
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true),
        image
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (image.status && image.status !== 'CORRECT')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "danger",
                      size: "small",
                      class: "me-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(image.status), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (image.manual)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "warning",
                      size: "small",
                      class: "me-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("label.manual")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (image.alert)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      type: "warning",
                      size: "small",
                      class: "me-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(image.alert)), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (image.status_environment)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 3,
                      type: image.status_environment === 'CORRECT' ? 'success' : 'warning',
                      size: "small",
                      class: "me-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(image.status_environment)), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"]))
                  : _createCommentVNode("", true),
                (image.camera)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 4,
                      type: "success",
                      size: "small",
                      class: "me-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(image.numCamera ? image.camera + image.numCamera : image.camera), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (image.origin === 'MASSIVE_CAPTURE')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 5,
                      type: "info",
                      size: "small",
                      class: "me-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("label.massiveCapture")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              (image?.dateTime)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (this.modal)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.formatDate(image?.dateTime)), 1))
                      : (_ctx.checkTime(image.interval, image.dateTime) === 'warning')
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            class: "checkTimeWarning checkTime",
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(image?.dateTime)), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (_ctx.checkTime(image.interval, image.dateTime) === 'danger')
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 2,
                              class: "checkTimeDanger checkTime",
                              type: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formatDate(image?.dateTime)), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.formatDate(image?.dateTime)), 1))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2))
  }), 128))
}